import { useMemo } from 'react';
import { createDownloadLink } from './useDownloadLink';
import { FlowEnum } from 'src/openapi/types/FlowEnum';

export function useLogDownloadLink(
  url: string | undefined,
  flow?: FlowEnum | null | '',
  logId = 'download_import_log',
  onShowError?: (visible: boolean) => void,
) {
  return useMemo(() => {
    return createDownloadLink(url ?? '', flow, logId, '', onShowError);
  }, [url, flow, logId]);
}
